/**
 * Digital Design, adesso che le tre divisioni sono una sezione sola.
 *
 * Questa pagina mostrava le **consegne** (Deliverable), che non sono progetti:
 * era il motivo per cui un progetto di divisione Design non compariva da
 * nessuna parte. Le consegne non sono state buttate, sono andate in due posti,
 * e il motivo è che il legame col progetto è facoltativo:
 *
 *  - dentro la scheda del progetto, come scheda "Consegne": sono il lavoro di
 *    quel progetto;
 *  - dentro Progetti, vista "Consegne": è la vista d'insieme, e mostra anche
 *    quelle **senza progetto**, che altrimenti sarebbero sparite.
 *
 * Il vecchio indirizzo `/divisions/design` resta vivo e porta lì.
 */
import { ProjectsPage } from '../projects/ProjectsPage';

export function DigitalDesignPage() {
  return <ProjectsPage initialVista="consegne" />;
}
